<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <bita-form ref="filterForm">
            <div slot="body">
              <div class="row">
                <bita-input
                    type="text"
                    name="name"
                    label="جستجو"
                    validation-container-class="col-lg-3"
                    input-class="form-control"
                    v-model.lazy="filters.search"
                    @keyup.enter="loadData()"
                />
                <div class="col-lg-4">
                  <a class="margin-top btn btn-success" @click="loadData()">
                    جستجو
                  </a>
                  <a
                      class="margin-top margin-right btn btn-warning"
                      @click="resetFilters()"
                  >
                    پاک سازی
                  </a>
                </div>
              </div>
            </div>
          </bita-form>
          <bita-grid
              ref="grid"
              :columns="gridColumns"
              :read-data="readData"
              :grid-server-side="true"
              :schema-total="'total'"
              :schema-data="'data'"
              :server-paging="true"
              :batch="true"
              :page-size="pageSize"
              :current-page="currentPage"
              :has-row-number="true"
          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>
<script>

import {designerApi} from "@/api/apiManagement.js";

export default {
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "پنل طراح",
          link: "/designer",
          active: false,
        },
        {
          title: "پرداخت ها",
          link: "",
          active: true,
        },
      ],
      filters: {},
      isLoadingGrid: false,
      isLoadingModal: false,

      gridColumns: [
        { field: "id", title: "شناسه" },
        // { field: "family", title: "نام شخص" },
        {
          field: "amount",
          title: "مبلغ",
          template: (e) => (e.amount ? this.$thousandSeprator(e.amount) : "-"),
        },
        {
          field: "tracking_code",
          title: "کد رهگیری",
        },
        {
          field: "description",
          title: "توضیحات",
        },
        {
          field: "created_at",
          title: "تاریخ",
          template: ({ created_at }) => this.$getJalaliDateTime(created_at),
        },
      ],
    };
  },

  mounted() {
    if (this.$route.query) this.filters = this.$route.query;
    this.loadData();
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
  },
  methods: {
    resetFilters() {
      this.filters = {};
      this.$refs.filterForm.reset();
      let selects = Object.values(this.$refs);
      selects.forEach((el) => {
        if (el && el.emptyKendo) el.emptyKendo();
      });
      this.loadData()
    },
    readData(e) {
      this.$resetGrid();
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.isLoadingGrid = true;
      designerApi
          .myDeposits({
            page_size: this.pageSize,
            page: this.currentPage,
            ...this.filters,
          })
          .then(({data}) => {
            e.success(data.entity);
          })
          .catch(() => {
            e.success([]);
          })
          .finally(() => {
            this.isLoadingGrid = false;
          });
    },

    loadData() {
      this.$refs.grid.loadDataSource();
    },

    gridCommands() {
      return [];
    },
  },
};
</script>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
.badge {
  margin: 2px;
  font-size: 13px !important;
  font-weight: 800;
}
</style>
